import React from 'react';
import PropTypes from 'prop-types';

const DeletePayeeMsg = ({ selectedPayeeName, deletePayeeSuccessMessage }) => (
	<span>
		<strong>{selectedPayeeName}</strong> {deletePayeeSuccessMessage}
	</span>
);

DeletePayeeMsg.propTypes = {
	deletePayeeSuccessMessage: PropTypes.string,
	selectedPayeeName: PropTypes.string,
};

export default DeletePayeeMsg;
